module.exports = __webpack_public_path__ + "static/media/personal.ca35ad6c.jpg";